<div class="downgrade a-fx-col a-fx-gap-32">
    <div class="h2">
        {{ 'settings.customer-subscription.change-your-plan' | translate }}
    </div>

    <nz-alert nzShowIcon nzType="warning" [nzDescription]="alertDescriptionTmpl">
        <ng-template #alertDescriptionTmpl>
            <div
                [innerHTML]="
                    'settings.customer-subscription.before-downgrade' + ((isAgency$ | async) ? '-agency' : '')
                        | translate
                            : {
                                  currentPlan:
                                      ('settings.customer-subscription.plans.' + currentPlan?.type | translate),
                                  newPlan: ('settings.customer-subscription.plans.' + newPlan?.type | translate),
                              }
                "
            ></div>
        </ng-template>
    </nz-alert>

    <div class="downgrade-steps a-fx-col a-fx-gap-8">
        <label
            *ngFor="let step of steps$ | async; trackBy: trackByKey"
            nz-checkbox
            [ngModel]="step.active"
            (ngModelChange)="updateStep$.next({ key: step.key, active: $event, platforms: step.platforms })"
        >
            <ng-container
                *ngIf="
                    'settings.customer-subscription.downgrade-actions.' + step.label
                        | translate: { price: step.price | microsToNumber | formatCurrency: currency } as label
                "
            >
                <span [innerHTML]="label | translatePart: 0"></span>
                <a
                    [href]="step.link"
                    target="_blank"
                    [innerHTML]="label | translatePart: 1"
                    (click)="$event.stopPropagation()"
                ></a>
                <span [innerHTML]="label | translatePart: 2"></span>
            </ng-container>
        </label>
    </div>
</div>
